<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row justify="center" dense>
            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="Course Marks Calculation" value="course" color="#0f2027"></v-radio>
                <v-radio label="Annual Marksheet Calculation" value="marksheet" color="#0f2027"></v-radio>
                <v-radio label="Marathi Marksheet Remark" value="marathi_marksheet" color="#0f2027"></v-radio>
            </v-radio-group>
        </v-row>
        <v-card class="box" v-if="ay_std_div_list != null && radios=='course'">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Annual Course Marks Calculation </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
              getDiv();
              getStandardCourse();
            " persistent-hint hint="Please select standard" @click="putnull" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="crs_id" item-value="c_id"
                        :items="crs_list" item-text="course" label="Course" outlined persistent-hint
                        hint="Please select course" />
                </v-col>

                <v-col cols="12" sm="2" md="2" v-if="
            sel_ay_data && sel_std_data && div && crs_id && assessment_detail
          ">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row v-if="leraner_marks!=''" dense justify="center"> 
                <strong><v-icon color="yellow">mdi-checkbox-blank-circle</v-icon> - Absent / Medical Leave  <v-icon color="red">mdi-checkbox-blank-circle</v-icon> - Marks entry not done for all exam</strong>
            </v-row>
            <div class="scroll" v-if="leraner_marks!=''">
                <v-simple-table dense class="elevation-1" v-if="leraner_marks!=''" style="width:140%;" height="500px">
                    <thead>
                        <tr>
                            <th class="">
                                <center>Roll No.</center>
                            </th>
                            <th class="">
                                <center>Registration No.</center>
                            </th>
                            <th class="">
                                <center>Name</center>
                            </th>
                            <th class="" v-for="header in ass_details_for_marksheet" :key="header">
                                <center>{{ header }}</center>
                            </th>
                            <th class="">
                                <center>Total Marks</center>
                            </th>
                            <th class="">
                                <center>Out Off Marks</center>
                            </th>
                            <th class="">
                                <center>Average Calculation Count</center>
                            </th>
                            <th class="">
                                <center>Calculated Average</center>
                            </th>
                            <th class="">
                                <center>Already Saved Average</center>
                            </th>
                            <th class="">
                                <center>Comment</center>
                            </th>
                            <th class="">
                                <center>Grade</center>
                            </th>
                            <th class="">
                                <v-checkbox
                                    color="success" dense label="Hide Show Average" v-model="hide_show" @change="changeStatus(hide_show)"></v-checkbox>
                                <!-- <center>Hide Show Average 
                                    </center> -->
                            </th>
                            <!-- <th class="">
                                <center>Save/Update</center>
                            </th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in leraner_marks" :key="s.cid"
                        :class="{
                            'bg-yellow': s.all_marks.includes('Absent'),
                            'bg-red': s.all_marks.includes('--') && !s.all_marks.includes('Absent')
                        }">
                            <td>{{ s.rollno }}</td>
                            <td>{{ s.registration_number }}</td>
                            <td>{{ s.name }}</td>
                            <td v-for="(header, index) in s.all_marks" :key="index">
                                <center>
                                    {{ header }}
                                </center>
                            </td>
                            <td>
                                <input placeholder="Enter total marks" class="input text-center" type="number"
                                    v-model="s.total_marks" :name="s.cid" :rules="[v => !!v || 'Required' || v >= 0]"
                                    @keypress="isNumber($event)" />
                                <!-- {{ s.total_marks }} -->
                            </td>
                            <td>
                                <input placeholder="Enter out off marks" class="input text-center" type="number"
                                    v-model="s.out_off_marks" :name="s.cid" :rules="[v => !!v || 'Required' || v >= 0]"
                                    @keypress="isNumber($event)" />
                                <!-- {{ s.out_off_marks }} -->
                            </td>
                            <td>
                                <input placeholder="Enter Avg Count" class="input text-center" type="number"
                                    v-model="s.avg_count" :name="s.cid" :rules="[v => !!v || 'Required' || v >= 0]"
                                    @keypress="isNumber($event)" @change="division_cal(s)" />
                            </td>
                            <td>
                                <input placeholder="Enter Avg Count" class="input text-center" type="number"
                                    v-model="s.avg" :name="s.cid" :rules="[v => !!v || 'Required' || v >= 0]"
                                    @keypress="isNumber($event)" />

                                <!-- <center>
                                    {{ s.avg }} 
                                </center> -->
                            </td>
                            <td>
                                {{s.lcm_percentage}}
                            </td>
                            <td>
                                <v-autocomplete rounded dense required v-model="s.remark_comment" :items="remarks_list"
                                    item-text="remark" return-object label="Comment" class="pt-2 pb-0" outlined clearable/>
                            </td>
                            <td>
                                <v-autocomplete dense required outlined rounded color="#0F2027" v-model="s.grade"
                                    :items="grade_details" item-text="gradename" label="Grade" persistent-hint
                                    hint="Please select grade" />
                            </td>
                            <td>
                                <center>
                                    <v-switch v-model="s.hide_show_percentage"
                                        :color="s.hide_show_percentage ? 'success' : 'primary'"></v-switch>
                                </center>
                            </td>
                            <!-- <td><v-btn :class="{
                            'bg-yellow': s.all_marks.includes('Absent'),
                            'bg-red': s.all_marks.includes('--') && !s.all_marks.includes('Absent')
                        }" x-small :disabled="s.all_marks.includes('--')" @click="savesinglecoursemarks(s)">save/update</v-btn></td> -->
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
            <center><v-btn v-if="leraner_marks!=''" class="button"
                    @click="saveallstudmarks(leraner_marks)">save/update</v-btn></center>
        </v-card>


        <v-card class="box" v-if="ay_std_div_list != null && radios=='marksheet'">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Annual Course Marks Calculation </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
              getDiv();
            " persistent-hint hint="Please select standard" @click="putnull" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="
            sel_ay_data && sel_std_data && div  && assessment_detail
          ">
                    <v-btn class="mt-6 button" @click="getreport_marksheet()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="leraner_marks_markseet!=''">
                <v-simple-table fixed-header dense class="elevation-1">
                    <thead>
                        <tr>
                            <th class="">
                                <center>Sr. No.</center>
                            </th>
                            <th class="">
                                <center>Roll No.</center>
                            </th>
                            <th class="">
                                <center>Registration No.</center>
                            </th>
                            <th class="">
                                <center>Name</center>
                            </th>
                            <th class="">
                                <center>Added Remark</center>
                            </th>
                            <!-- <th class=""><center>Add New / Update Remark</center></th> -->
                            <th class="">
                                <center>Hide Show Percentage</center>
                            </th>
                            <th class="">
                                <center>Save/Update</center>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in leraner_marks_markseet" :key="s.lid">
                            <td>{{ index + 1 }}</td>
                            <td>{{ s.rollno }}</td>
                            <td>{{ s.registration_number }}</td>
                            <td>{{ s.name }}</td>
                            <td>
                                <v-textarea outlined name="input-7-4" counter maxlength="500"
                                    hint="Describe in 500 characters" v-model="s.remark"
                                    label="Enter Remark"></v-textarea>
                                <!-- {{ s.remark }} -->
                            </td>
                            <!-- <td>
                                <v-autocomplete multiple rounded dense required v-model="s.remark" :items="remarks_list_marksheet" item-text="remark" item-value="remark" item-name="remark" label="Comment" class="pt-2 pb-0" outlined />
                            </td> -->
                            <td>
                                <center>
                                    <v-switch v-model="s.hide_show_percentage"
                                        :color="s.hide_show_percentage ? 'success' : 'primary'"></v-switch>
                                </center>
                            </td>
                            <td><v-btn class="button" x-small @click="saveSingleLMS(s)">save/update</v-btn></td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <center><v-btn class="button" @click="saveAllStudLMS(leraner_marks_markseet)">save/update</v-btn>
                </center>
            </v-col>
        </v-card>

        <v-card class="box" v-if="ay_std_div_list != null && radios=='marathi_marksheet'">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Annual Course Marks Calculation </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
              getDiv();
            " persistent-hint hint="Please select standard" @click="putnull" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="
            sel_ay_data && sel_std_data && div
          ">
                    <v-btn class="mt-6 button" @click="getreport_mararhi_marksheet()"
                        :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="leraner_marathi_markseet_data!=''">
                <v-simple-table fixed-header dense class="elevation-1">
                    <thead>
                        <tr>
                            <th class="">
                                <center>Sr. No.</center>
                            </th>
                            <th class="">
                                <center>Roll No.</center>
                            </th>
                            <th class="">
                                <center>Registration No.</center>
                            </th>
                            <th class="">
                                <center>Name</center>
                            </th>
                            <th class="">
                                <center>Added Remark</center>
                            </th>
                            <th class="">
                                <center>Save/Update</center>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in leraner_marathi_markseet_data" :key="s.lid">
                            <td>{{ index + 1 }}</td>
                            <td>{{ s.rollno }}</td>
                            <td>{{ s.registration_number }}</td>
                            <td>{{ s.name }}</td>
                            <td>
                                <v-textarea outlined name="input-7-4" counter maxlength="500"
                                    hint="Describe in 500 characters" v-model="s.remark"
                                    label="Enter Remark"></v-textarea>
                            </td>
                            <td><v-btn class="button" x-small @click="saveSingleLMartahiRemark(s)">save/update</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <center><v-btn class="button"
                        @click="saveAllStudLMartahiRemark(leraner_marathi_markseet_data)">save/update</v-btn></center>
            </v-col>
        </v-card>

    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

        data() {
            return {
                overlay: false,
                selected: [],
                // extraBreadcrumbItems: [


                // ],
                hide_show:false,
                // breadcrumbClass: "breadcrumb-style1",
                snackbar: false,
                course_list: [],
                crs_id: null,
                search: "",
                crs_list: [],
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                assessment_detail_list: [],
                assessment_detail: [],
                leraner_marks: [],
                standard: null,
                division: null,
                course: null,
                academicyear: null,
                ass_detail_list: null,
                learner_course_list: null,
                org_basic_data: [],
                remarks_list: [],
              //  remarks_list_marksheet:[],
                leraner_marks_markseet:[],
                leraner_marathi_markseet_data:[],
                grade_details:[],
                radios:[],
            };
        },

        methods: {
            changeStatus(hide_show){
                for( var i = 0; i < this.leraner_marks.length; i++ ){
                    if(hide_show){
                        this.leraner_marks[i].hide_show_percentage = true
                    }
                    else{
                        this.leraner_marks[i].hide_show_percentage = false
                    }
                }
            },
            division_cal(s){
                if(s.avg_count!=0){
                    s.avg = s.total_marks / s.avg_count
                }
            },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },

            myfunction() {
                for (var i = 0; i < this.learner_course_list.length; i++) {
                    // var formattter = this.learner_course_list[i].converted_marks.toFixed(2)
                    var formattter = Math.round(this.learner_course_list[i].converted_marks);
                    //  alert(formattter)
                    //this.learner_course_list[i].converted_marks = formattter
                    //return
                }
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            async saveallstudmarks(item) {
                const data = {
                    marks_data: item,
                };
                try {
                    const res = await axios.post("/WWSExamination/saveallstudcoursemarks", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Marks save successfully");
                        this.getreport();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async savesinglecoursemarks(item) {
                try {
                    const res = await axios.post("/WWSExamination/savesinglecoursemarks", item);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Marks save successfully");
                        this.getreport();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async saveAllStudLMS(item) {
                const data = {
                    marks_data: item,
                };
                try {
                    const res = await axios.post("/WWSExamination/saveAllStudLMS", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.getreport_marksheet();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async saveSingleLMS(item) {
                try {
                    const res = await axios.post("/WWSExamination/saveSingleLMS", item);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.getreport_marksheet();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async saveAllStudLMartahiRemark(item){
                const data = {
                    marks_data: item,
                };
                try {
                    const res = await axios.post("/WWSExamination/saveAllStudLMartahiRemark", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.getreport_mararhi_marksheet();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async saveSingleLMartahiRemark(item) {
                try {
                    const res = await axios.post("/WWSExamination/saveSingleLMartahiRemark", item);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.getreport_mararhi_marksheet();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async getreport_marksheet(){
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    sem: this.sem,
                    div: this.div,
                };
                this.fetch_loader = true;
                try {
                    const res = await axios.post("/WWSExamination/annualMarksheetCalculation", data);
                    if (res.data.flag == "YES") {
                       // this.remarks_list_marksheet = res.data.remarks_list
                        this.leraner_marks_markseet = res.data.leraner_marks
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async getreport_mararhi_marksheet(){
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    div: this.div,
                };
                this.fetch_loader = true;
                try {
                    const res = await axios.post("/WWSExamination/marathiMarksheetRemarkInfo", data);
                    if (res.data.flag == "YES") {
                        this.leraner_marathi_markseet_data = res.data.leraner_marks
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async getreport() {
                this.hide_show = false
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_id: this.crs_id,
                    sem: this.sem,
                    div: this.div,
                };
                this.fetch_loader = true;
                try {
                    const res = await axios.post("/WWSExamination/annualCourseMarksCalculation", data);
                    if (res.data.flag == "YES") {
                        this.leraner_marks = res.data.leraner_marks;
                        this.remarks_list = res.data.remarks_list;
                        this.ass_details_for_marksheet = res.data.ass_details_for_marksheet;
                        this.grade_details = res.data.grade_details
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },

            getStandardCourse() {
                // let div = this.div.div_id;
                // if (this.div.div_id) {
                //     div = this.div.div_id;
                // } else {
                //     div = this.div;
                // }
                this.role = localStorage.getItem("para_role");
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    role: this.role,
                };
                axios
                    .post("/Examination/getStandardCourse_WWS", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list = res.data.courses_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered for this standard..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                // this.div_list = ["All"];
                // this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                // this.div_list.unshift("All");
                //this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                this.role = localStorage.getItem("para_role");
                const data = {
                    role: this.role,
                };
                axios
                    .post("/commonAPI/get_ay_std_div_wws",data)
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        //     this.sel_ay_data = res.data.curr_ay;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
 .scroll {
        overflow-x: scroll;
    }
    input[type="number"] {
        width: 70%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        /*  img {
            width: 100% !important;
        }*/
        body,
        tr,
        th,
        td {
            font-size: 14pt !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            /*size: 15.5in 15.5in;*/
            size: 16in 20in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
        .table-data {
            height: 100% !important;
            overflow-x: hidden;
            overflow-y: hidden !important;
        }
    }
    .trust-logo {
        width: 86%;
    }
    .schl-logo {
        width: 86%;
    }
    tr:hover {
    background-color: unset  !important;
    cursor: default !important;
    }
    .bg-yellow {
    background-color: yellow !important;
    font-weight: bold;
    }
    .bg-red {
        background-color: red !important; /* light red */
        font-weight: bold;
    }
    .bg-yellow:hover {
    background-color: yellow !important;

    }
    .bg-red:hover {
        background-color: red !important; /* light red */
    }
    
</style>
